import { Field as FieldRC } from 'rc-field-form';
import { cloneElement, FC, useEffect, useState } from 'react';
import Group from './Group';
import { Error, Icon, Label, Name, Title } from './style';
import { Props } from './types';

interface I<T = unknown> extends FC<T> {
  Group: typeof Group;
}

const Field: I<Props> = ({ name, label, labelIcon, labelPalette, noStyle, labelInline, lockable, isLocked, isLockedByDefault, children, ...restProps }) => {
  const [locked, setLocked] = useState(isLocked ?? isLockedByDefault ?? false);

  useEffect(() => {
    if (typeof isLocked === 'boolean') {
      setLocked(isLocked);
    }
  }, [isLocked]);

  if (noStyle) {
    return (
      <FieldRC name={name} {...restProps}>
        {(control, meta, form) => {
          const childNode =
            typeof children === 'function'
              ? children(
                  {
                    ...(lockable
                      ? {
                          disabled: locked,
                        }
                      : {}),
                    ...control,
                  },
                  meta,
                  form,
                )
              : cloneElement(children as React.ReactElement, {
                  ...control,
                  name,
                });

          return childNode;
        }}
      </FieldRC>
    );
  }

  return (
    <FieldRC name={name} {...restProps}>
      {(control, meta, form) => {
        const error: string = (name && form.getFieldError(name)[0]) || '';

        const childNode =
          typeof children === 'function'
            ? children(
                {
                  ...(lockable
                    ? {
                        disabled: locked,
                      }
                    : {}),
                  ...control,
                },
                meta,
                form,
              )
            : cloneElement(children as React.ReactElement, {
                ...control,
                name,
                ...(lockable
                  ? {
                      disabled: locked,
                    }
                  : {}),
              });

        return (
          <Label labelInline={labelInline}>
            {label && (
              <Title labelPalette={labelPalette}>
                {labelIcon && <Icon>{labelIcon}</Icon>}
                {label && <Name>{label}</Name>}
              </Title>
            )}
            {childNode}
            {error && <Error>{error}</Error>}
          </Label>
        );
      }}
    </FieldRC>
  );
};

Field.Group = Group;

export default Field;
